/** The room code as chunky candy letter tiles. */
export function CodeTiles({ code, size = 44 }: { code: string; size?: number }) {
  return (
    <span className="inline-flex gap-[0.14em] align-middle" style={{ fontSize: size }} aria-label={code.split("").join(" ")}>
      {code.split("").map((ch, i) => (
        <span key={i} className="code-tile" style={{ transform: `rotate(${[-3, 2, -1.5, 3, -2][i % 5]}deg)` }}>
          {ch}
        </span>
      ))}
    </span>
  );
}
